// extracted by mini-css-extract-plugin
module.exports = {"heading":"Headings_heading__3zyNA"};